import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle` 
:root {
  --background: #f8f2f5;
  --red: #e52e40;
  --blue: #5429cc;
  --green: #33cc95;
  
  --blue-light: #6933ff;

  --text-light: #363f5f;
  --text-body: #969cb3;

  --background: #f0f2f5;
  --shape: #ffff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  @media (max-width: 1080px) {
    font-size: 93.75%;
  }

  @media (max-width: 720px) {
    font-size: 87.5%;
  }
}

body, input, textarea, button {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
}

h1, h2, h3, h4, h5, h6, strong {
  font-weight: 600;
} 

body {
  background: var(--background);
  -webkit-font-smoothing: antialiased;
}

button {
  cursor: pointer
}

[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.react-modal-overlay,
.react-modal-content {
  background-color: rgba(0,0,0,0.5);

  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;
} 


.react-modal-overlay {
  @media (max-width: 576px) {
    align-items:flex-end;
  }
}

.react-modal-content {
  width: 100%;
  max-width: 576px;
  background-color: var(--background);
  padding: 3rem;
  position: relative;
  border-radius: 0.25rem;

  @media (max-width: 576px) {
    border-radius: 1rem;
  }
  
}

.react-modal-close {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    border: 0;
    background: transparent;

    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.8);
    }
  }
`
